import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const BookingDraftContext = createContext({
  draft: null,
  setBookingDraft: () => {},
});

/**
 * Homepage publishes the urgency tile that is already selected (Same day by default)
 * so other booking entry points on that page can carry it to login.
 * Cleared when the homepage unmounts. Not a price source.
 */
export function BookingDraftProvider({ children }) {
  const [draft, setDraft] = useState(null);
  const setBookingDraft = useCallback((next) => {
    setDraft(next);
  }, []);
  const value = useMemo(() => ({ draft, setBookingDraft }), [draft, setBookingDraft]);

  return (
    <BookingDraftContext.Provider value={value}>
      {children}
    </BookingDraftContext.Provider>
  );
}

export function useBookingDraft() {
  return useContext(BookingDraftContext);
}
